module.exports = __webpack_public_path__ + "img/testimonial-jose-b.8f8f402b.png";